import {Alert, Link} from '@mui/material'
import React, {useContext} from 'react'
import {Trans} from 'react-i18next'
import {YesNoOptions} from '../contexts/types'
import {AppContext} from "../contexts/AppContextProvider";
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";

type IRSAlertProps = { wasOpenedOrDropped: YesNoOptions }

const IRSAlert: React.FC<IRSAlertProps> = ({wasOpenedOrDropped}) => {
    const {countryCode} = useContext(AppContext)
    const {tns} = useContext(OrgCustomizationContext)

    const getIrsReturnFormUrl = () => {
        const language = navigator.language.split('-')[0].toLowerCase()

        if (countryCode === 'us') {
            return 'implant_replacement_form_us.pdf'
        }

        if (countryCode === 'ca') {
            return language === 'fr'
                ? 'service_de_remplacement_dimplant.pdf'
                : 'implant_replacement_form_ca.pdf'
        }

        if (countryCode === 'hk') {
            return 'hk_irs_form.pdf'
        }
    }

    return (
        <>
            {getIrsReturnFormUrl() && wasOpenedOrDropped === 'YES' && (
                <Alert severity='info' sx={{width: {md: '600px', sm: '100%'}}}>
                    <Trans i18nKey={tns('pt_irs_form')}>
                        -
                        <Link href={getIrsReturnFormUrl()} sx={{color: 'primary.main'}}>
                            -
                        </Link>
                        -
                    </Trans>
                </Alert>
            )}
        </>
    )
}

export default IRSAlert
